import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Dictionary from 'components/Dictionary';

import Dialog from 'components/Dialog';
import TextField from '@material-ui/core/TextField';

import formStyles, { gridStyle, Row, RowInner, ColCard } from 'utils/formStyles';

import { notify } from 'reducers/NotifierReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { closeEditWarrantParty } from 'reducers/DialogsReducer';
import { getService } from 'reducers/service';
import { addCreatedUpdatedBy, addUpdatedBy, getFullName } from 'utils/functions';
import { Grid } from '@mui/material';
import FormSpinner from 'components/FormSpinner';
import FormDivider from 'components/FormDivider';

const useStyles = makeStyles(() => ({
  ...formStyles,
  item: gridStyle(200, 800),
  item2: {
    width: '100%',
  },
  field: gridStyle(210, 400),
}));

function WarrantPartyEditDialog(props) {
  const classes = useStyles();
  const { data } = props;

  const [personDetails, setPersonDetails] = useState({
    FirstName: data.FirstName || '',
    MiddleName: data.MiddleName || '',
    LastName: data.LastName || '',
    NickName: data.NickName || '',
    Prefix: data.Prefix || '',
    Suffix: data.Suffix || '',
  });

  const service = getService('rms-warrant');
  const dictionary = useSelector((state) => state.dictionary);
  const { codeNamePrefixes, codeNameSuffixes } = dictionary;
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();

  //actions

  const onChange = (name, value) => {
    setPersonDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const close = () => {
    props.onClose();
  };

  const save = () => {
    setShowSpinner(true);

    const updateData = addUpdatedBy({
      ...data,
      ...personDetails,
      FullName: getFullName(personDetails),
      Prefix: personDetails.Prefix?.Code || personDetails.Prefix || null,
      Suffix: personDetails.Suffix?.Code || personDetails.Suffix || null,
    });

    service
      .patch(data.ptsWarrantID, { type: 'warrant', data: updateData })
      .then((res) => {
        props.notifyDataUpdate({
          type: 'single-warrant',
          data: {},
        });

        setShowSpinner(false);
      })
      .catch((error) => {
        setShowSpinner(false);

        dispatch(notify('Warrant could not be updated!', 'error'));
        console.log('Warrant update error: ', error);
      });
  };

  const renderPrefix = () => {
    const value =
      codeNamePrefixes.find(
        (item) => item.Code === (personDetails.Prefix?.Code || personDetails.Prefix)
      ) || null;

    return (
      <Dictionary
        options="codeNamePrefixes"
        className={classes.item2}
        onChange={(e, value) => onChange('Prefix', value)}
        value={value}
        // formType={personId ? 'edit' : 'add'}
        label="Prefix"
        // error={error}
      />
    );
  };

  const renderFirstName = () => {
    return (
      <TextField
        label="First Name"
        variant="outlined"
        onChange={(e) => {
          onChange('FirstName', e.target.value);
        }}
        value={personDetails.FirstName}
        className={classes.item2}
        size="small"
      />
    );
  };

  const renderMiddleName = () => {
    return (
      <TextField
        label="Middle Name"
        variant="outlined"
        onChange={(e) => {
          onChange('MiddleName', e.target.value);
        }}
        value={personDetails.MiddleName}
        className={classes.item2}
        size="small"
      />
    );
  };

  const renderLastName = () => {
    return (
      <TextField
        label="Last Name"
        variant="outlined"
        onChange={(e) => {
          onChange('LastName', e.target.value);
        }}
        value={personDetails.LastName}
        className={classes.item2}
        size="small"
      />
    );
  };

  const renderSuffix = () => {
    const value =
      codeNameSuffixes.find(
        (item) => item.Code === (personDetails.Suffix?.Code || personDetails.Suffix)
      ) || null;
    return (
      <Dictionary
        options="codeNameSuffixes"
        className={classes.item2}
        onChange={(e, value) => onChange('Suffix', value)}
        value={value}
        label="Suffix"
      />
    );
  };

  const renderNickName = () => {
    return (
      <TextField
        label="Nick Name"
        variant="outlined"
        onChange={(e) => {
          onChange('NickName', e.target.value);
        }}
        value={personDetails.NickName}
        className={classes.item2}
        size="small"
      />
    );
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" variant="contained" autoFocus onClick={save}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog
      toolbar
      maxWidth="lg"
      onClose={close}
      title="Edit Warrant Party"
      actions={renderActions()}>
      {showSpinner && <FormSpinner />}
      <Row>
        <ColCard minWidth={1000}>
          <FormDivider title={'Person'} />

          <Grid container xs={12} spacing={1}>
            <Grid item xs={3} lg={2}>
              {renderPrefix()}
            </Grid>
            <Grid item xs={3} lg={2}>
              {renderFirstName()}
            </Grid>
            <Grid item xs={3} lg={2}>
              {renderMiddleName()}
            </Grid>
            <Grid item xs={3} lg={2}>
              {renderLastName()}
            </Grid>
            <Grid item xs={3} lg={2}>
              {renderSuffix()}
            </Grid>
            <Grid item xs={3} lg={2}>
              {renderNickName()}
            </Grid>
          </Grid>
        </ColCard>
      </Row>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    dictionary: state.dictionary,
  };
};

export default connect(mapStateToProps, {
  closeEditWarrantParty,
  notifyDataUpdate,
  notify,
  handleError,
})(WarrantPartyEditDialog);
